import { render, staticRenderFns } from "./salesBatchReview.vue?vue&type=template&id=4727ed3f"
import script from "./salesBatchReview.vue?vue&type=script&lang=js"
export * from "./salesBatchReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports